import { Rect } from '@st/geom'

export type ScrollGeometry = {
  scrollAreaRect: Rect
  viewportRect: Rect
}

export function getScrollGeometry(scrollElement: HTMLElement): ScrollGeometry {
  const viewportDOMRect = scrollElement.getBoundingClientRect()

  const scrollAreaRect: Rect = {
    x: viewportDOMRect.x - scrollElement.scrollLeft,
    y: viewportDOMRect.y - scrollElement.scrollTop,
    width: scrollElement.scrollWidth,
    height: scrollElement.scrollHeight
  }

  const viewportRect: Rect = {
    x: viewportDOMRect.x,
    y: viewportDOMRect.y,
    width: scrollElement.clientWidth,
    height: scrollElement.clientHeight
  }

  return moveOriginToZero({
    viewportRect: viewportRect,
    scrollAreaRect: scrollAreaRect
  })
}

function moveOriginToZero(scrollGeometry: ScrollGeometry): ScrollGeometry {
  return {
    scrollAreaRect: {
      x: 0,
      y: 0,
      width: scrollGeometry.scrollAreaRect.width,
      height: scrollGeometry.scrollAreaRect.height
    },
    viewportRect: {
      x: scrollGeometry.viewportRect.x - scrollGeometry.scrollAreaRect.x,
      y: scrollGeometry.viewportRect.y - scrollGeometry.scrollAreaRect.y,
      width: scrollGeometry.viewportRect.width,
      height: scrollGeometry.viewportRect.height
    }
  }
}
